// extracted by mini-css-extract-plugin
export var acceptButton = "_29-5";
export var fullContent = "_29-4";
export var link = "_29-6";
export var linkIcon = "_29-7";
export var sideContent = "_29-3";
export var sideImage = "_29-2";
export var sideImageWrapper = "_29-1";
export var splitLayout = "_29-0";